import { useContext } from 'react';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';

export default function useCurrentSubscriptionType() {
  const context = useContext(GlobalContext);

  const subscriptionType = context.state.subscription?.subscriptionType || null;
  const isLoading = !context.state.loaded;

  return {
    subscriptionType,
    isLoading,
  };
}
